(function (window, document, $, ajax_url) {
})(window, document, jQuery, ajax_url);
